module.exports = __webpack_public_path__ + "img/89-thickbox_default.0d2bc0d5.jpg";